'use client'
import React, { useState } from 'react'
import parse from 'html-react-parser';
import tailwindConfig from '@tailwind.config'


const HtmlComponent = ({ subcategory, html, dictionary }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.content,
    };
    const style2 = {
        color: tailwindConfig.theme.extend.colors.content,
        height: 120,
        overflow: 'hidden',
        z: 10
    };

    const maxContentLength = 200; // Maximum characters to display before truncating
    const [showFullContent, setShowFullContent] = useState(false);

    const truncatedContent = html[0]?.slice(0, maxContentLength);
    const isContentTruncated = html[0]?.length > maxContentLength;

    const toggleContent = () => {
        setShowFullContent(!showFullContent);
    };

    if (html?.[0]?.trim()?.length == 0) return null

    return (
        <div className='mb-3 pb-3 border-b-[1px] border-b-forth'>
            <h2 className='text-maincolor font-semibold text-xl'>{dictionary.aboutThis}{subcategory}</h2>
            <div /*className='text-justify'*/>
                {!showFullContent && (
                    <>
                        <div style={style2}>
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='relative w-full flex flex-row-reverse'>
                                <div className='absolute right-0 left-0 top-[-20px] h-[20px] bg-gradient-to-b from-transparent to-light'></div>
                                <button
                                    className="text-maincolor mt-2 cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light"
                                    onClick={toggleContent}
                                >
                                    {showFullContent ? `${dictionary.readLess}` : `${dictionary.readMore}`}
                                </button>
                            </div>
                        )}
                    </>
                )}
                {showFullContent && (
                    <>
                        <div style={style}>
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='w-full flex flex-row-reverse'>
                                {/* <br /> */}
                                <button
                                    className="text-maincolor mt-2 cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light z-40"
                                    onClick={toggleContent}
                                >
                                    {showFullContent ? `${dictionary.readLess}` : `${dictionary.readMore}`}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default HtmlComponent